import { createDomain } from 'effector'

export type FormValues = {
  amount: number
  comment?: string
}

const domain = createDomain('entities.debt.depositRepaymentModal')

export const openDepositRepayment = domain.createEvent()
export const closeDepositRepayment = domain.createEvent()

export const $isDepositRepaymentOpen = domain
  .createStore<boolean>(false)
  .on(openDepositRepayment, () => true)
  .on(closeDepositRepayment, () => false)
